// extracted by css-extract-rspack-plugin
export default {"brazeBanner":"T3rQch3c"};